import { useMemo } from 'react'
import { useSignedInAccount } from '../../contexts/AccountContext'
import { useCatalog } from '../../contexts/CatalogContext'
import { useFeatures } from '../../hooks/useFeatures'
import { useSkinPlan } from '../../hooks/useSkinPlan'
import { isSoldOut } from '../../core/rules/stock'
import { giftCardCheck } from '../../utils/accountOrders'
import { journeyFacts, nextStep } from './nextStep'

/** De volgende stap voor de klant die nu kijkt, plus de feiten waar hij uit komt. */
export function useNextStep() {
  const { account } = useSignedInAccount()
  const { productById } = useCatalog()
  const features = useFeatures()
  const { items } = useSkinPlan()

  return useMemo(() => {
    const facts = journeyFacts(account, {
      planItems: items,
      isGiftCard: giftCardCheck(productById),
      canBuy: (id) => {
        const p = productById(id)
        return Boolean(p && !isSoldOut(p))
      },
      subscriptionsOn: features.subscriptions,
    })
    return { facts, step: nextStep(facts) }
  }, [account, items, productById, features.subscriptions])
}
